module.exports = __webpack_public_path__ + "img/background-main-mobile-kvota-eng.bdbf3586.svg";